import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CONFIGURATION } from 'src/configuration';
import { Tenant, MaintenanceWindow } from './tenant';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceService {
  private http = inject(HttpClient);
  private configuration = inject(CONFIGURATION);

  getMaintenances() {
    return this.http.get<Tenant[]>(`${this.configuration.apis.tenancy}/tenants/list?includeMaintenanceWindows=true`)
      .pipe(catchError(this.handleError));
  }

  getTenant(solutionId: string) {
    return this.http.get<Tenant>(`${this.configuration.apis.tenancy}/tenants?connectSolutionId=${solutionId}&includeMaintenanceWindows=true`)
      .pipe(catchError(this.handleError));
  }

  updateMaintenance(solutionId: string, payload: MaintenanceWindow) {
    return this.http.put(`${this.configuration.apis.tenancy}/maintenance/${solutionId}`, payload)
      .pipe(catchError(this.handleError));
  }

  deleteMaintenance(solutionId: string) {
    return this.http.delete<Tenant>(`${this.configuration.apis.tenancy}/maintenance/${solutionId}`)
      .pipe(catchError(this.handleError));
  }

  handleError(error: any): Observable<never> { //eslint-disable-line  @typescript-eslint/no-explicit-any
    if (error.error instanceof ErrorEvent) {
      // Client-side errors
      return throwError(() => `Error: ${error.message}`);
    } else {
      // Server-side errors
      return throwError(() => `Error: Backend returned code ${error.status}: ${error.message}`);
    }
  }
}
